var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#8E8E8E",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M12.02 2.91a6 6 0 0 0-6 6v2.89a4.8 4.8 0 0 1-.57 2.06L4.3 15.77a1.92 1.92 0 0 0 1.08 2.93 20.92 20.92 0 0 0 13.27 0 2 2 0 0 0 1.08-2.93l-1.15-1.91a4.9 4.9 0 0 1-.56-2.06V8.91a6.02 6.02 0 0 0-6-6z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#8E8E8E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M13.87 3.202a6.754 6.754 0 0 0-3.7 0 1.988 1.988 0 0 1 3.7 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#8E8E8E",
  strokeWidth: 1.5,
  d: "M15.02 19.059a3.01 3.01 0 0 1-3 3 3 3 0 0 1-2.12-.88 3 3 0 0 1-.88-2.12"
})));
export { SvgNotification as ReactComponent };
export default __webpack_public_path__ + "33f2f51c095ba90e93f9c58bc631be06.svg";